import {Component} from '@angular/core';
import {OrganizzazioniService} from "../../_services/organizzazioni.service";
import {ModalController} from "@ionic/angular";
import {MovimentiService} from "../../_services/movimenti.service";
import {ImportAnalysisResult} from "../../_models/ImportAnalysisResult";
import {SaveMessage} from "../../_helpers/save-message";

@Component({
  selector: 'app-import-modal',
  templateUrl: './import-modal.component.html',
  styleUrls: ['./import-modal.component.scss'],
})
export class ImportModalComponent {
  selectedFile?: File;
  analysisResult?: ImportAnalysisResult;
  tracciatoId = 0;
  loading = false;

  constructor(
    private organizzazioniService: OrganizzazioniService,
    private movimentiService: MovimentiService,
    private saveMessage: SaveMessage,
    private modalCtrl: ModalController) { }


  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0];
    this.analysisResult = undefined;
  }

  analyze() {
    if (!this.selectedFile) return;

    this.loading = true;
    this.analysisResult = null;
    this.movimentiService
      .analyzeMovimenti(this.organizzazioniService.organizzazioneId, this.tracciatoId, this.selectedFile!)
      .subscribe({
        next: res => {
          this.analysisResult = res;
          this.loading = false;
        },
        error: () => this.saveMessage.messageError("Ci sono problemi con l'analisi dei movimenti."),
      });
  }

  confirmImport() {
    if (!this.analysisResult) return;

    this.movimentiService.confirmMovimenti(this.analysisResult)
      .subscribe({
        next: () => {
          this.modalCtrl.dismiss(true, 'confirm');
        },
        error: () => {
          this.saveMessage.messageError("Ci sono problemi con l'importazione dei movimenti.");
        }
      });
  }

  cancel = () => this.modalCtrl.dismiss(false, 'cancel');
}
